import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { Suspense, lazy, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { cfpBaseUrl } from "../../network/urls";
import { getDate, getMonthName, getShortMonthName, getYear } from "../../services/Functions";
import "./CfcDashboard.scss";
const DashboardHeader = lazy(() => import("../../components/cfcDashboard/DashboardHeader"));
const InfoCard = lazy(() => import("../../components/cfcDashboard/InfoCard"));

const CfcDashboard = () => {
  const [viewBackdrop, setViewBackdrop] = useState(false);

  const { token, code } = useSelector(state => state.auth)
  const [dashboardData, setDashboardData] = useState([]);
  const [serviceCards, setServiceCards] = useState([
    {
      service: "New Connections",
      title1: "New",
      title2: "Connections",
      yearlyCounter: 0,
      month: getShortMonthName(),
      monthlyCounter: 0,
      color: "#FFE2E5",
    },
    {
      service: "Bill Installments",
      title1: "Bill",
      title2: "Installments",
      yearlyCounter: 0,
      month: getShortMonthName(),
      monthlyCounter: 0,
      color: "#EBDBFE",
    },
    {
      service: "Due Date Extensions",
      title1: "Due Date",
      title2: "Extensions",
      yearlyCounter: 0,
      month: getShortMonthName(),
      monthlyCounter: 0,
      color: "#FEF5C0",
    },
    {
      service: "Change of Attributes",
      title1: "Change of",
      title2: "Attributes",
      yearlyCounter: 0,
      month: getShortMonthName(),
      monthlyCounter: 0,
      color: "#FBE2CC",
    },
    {
      service: "Reconnection",
      title1: "Reconnection",
      yearlyCounter: 0,
      month: getShortMonthName(),
      monthlyCounter: 0,
      color: "#DCFCE7",
    },
  ])

  useEffect(() => {
    const callCFCDashboardAPI = async () => {
      setViewBackdrop(true)
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("officeCode", code);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
      };

      await fetch(cfpBaseUrl + "comman/getCFCDashboardStats", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
         
            setDashboardData(result.data);

            if (result.data) {
              const yearlyData = result.data.filter(item => item.Duration === 'Progressive')
              const currentMonthData = result.data.filter(item => item.Duration === 'CurrentMonth')
              setServiceCards(prevCards => {
                return prevCards.map(item => {
                  const yearlyMatch = yearlyData.find(data =>
                    data.Service.toLowerCase() === item.service.toLowerCase()
                  )
                  const monthlyMatch = currentMonthData.find(data =>
                    data.Service.toLowerCase() === item.service.toLowerCase()
                  )
                  return {
                    ...item,
                    yearlyCounter: yearlyMatch ? yearlyMatch.Total : 0,
                    monthlyCounter: monthlyMatch ? monthlyMatch.Total : 0
                  }
                })
              })
            }
          }
        })
        .catch((error) => console.error(error));
      setViewBackdrop(false);
    };
    callCFCDashboardAPI();
  }, [token]);

  return (
    <>
      <Box className="form-box">
        <div className="cfc-dashboard">
          <Suspense fallback={<div>Loading header...</div>}>
            <DashboardHeader
              title="Customer Services"
              serviceCards={serviceCards}
            />
          </Suspense>
          <div className="info-cards">
            <Suspense fallback={<div>Loading card...</div>}>
              <InfoCard title="Services" type="services" rows={getRowsData()} />
              <InfoCard
                title="Progressive"
                subTitle={getYear()}
                columns={["Pending", "Attended", "Total"]}
                rows={getAlignedDataByDuration(dashboardData, "Progressive")}
                type="progressive"
              />
              <InfoCard
                title="Monthly"
                subTitle={getMonthName(0)}
                columns={["Pending", "Attended", "Total"]}
                rows={getAlignedDataByDuration(dashboardData, "CurrentMonth")}
                type="progressive"
              />
              <InfoCard
                title="Daily"
                subTitle={getDate()}
                columns={["Pending", "Attended", "Total"]}
                rows={getAlignedDataByDuration(dashboardData, "Daily")}
                type="progressive"
              />
            </Suspense>
          </div>
        </div>
      </Box>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >

    </>
  );
};

// Services list for CFC Dashboard
export const cfcServicesList = [
  "New Connections",
  "Bill Installments",
  "Due Date Extensions",
  "Change of Attributes",
  "Reconnection"
];

export const getRowsData = () => cfcServicesList.map(service => ({ service }));

// Helper function to align data with services list (case-insensitive matching)
// Works with raw API data (uppercase keys: Service, Pending, Attended, Total, Duration)
// Returns null for missing data - InfoCard will display "-" for falsy values
export const getAlignedDataByDuration = (dashboardData, duration) => {
  const filteredData = dashboardData.filter(item => item.Duration === duration);
  return cfcServicesList.map(serviceName => {
    const match = filteredData.find(item =>
      item.Service.toLowerCase() === serviceName.toLowerCase()
    );
    if (match) {
      return {
        service: serviceName,
        pending: match.Pending,
        attended: match.Attended,
        total: match.Total
      };
    }
    return {
      service: serviceName,
      pending: null,
      attended: null,
      total: null
    };
  });
};

export default CfcDashboard;
